import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";
import { getTestInputDataDefinition } from "./DataDefinition";
import { MappingConfiguration } from "../../rule-engine-core/Mapping/MappingConfiguration";

export const getMappingEmpty = (): MappingConfiguration => {
    const mapppingDef = new MappingConfiguration();

    mapppingDef.inputData = getTestInputDataDefinition();

    const outdef = new DataDefinition();
    outdef.fields.push(new StringDataDefinition("fullName"));
    outdef.fields.push(new StringDataDefinition("email"));
    outdef.fields.push(new NumberDataDefinition("age"));
    outdef.fields.push(new StringDataDefinition("phone"));
    mapppingDef.executionResult = outdef;

    return mapppingDef;
};
